import initSubmitSlider from './components/submit-slider';
import initSubmitMemory from './components/submit-memory';
import initSubmitSearch from './components/submit-search';
import initSubmitValidation from './components/submit-validation';

const submitSlider = document.querySelector('.js-submit-slider');
const submitMemory = document.querySelector('.js-submit-memory');

if (submitSlider) {
    initSubmitSlider(submitSlider);
}

if (submitMemory) {
    initSubmitMemory(submitMemory);
    initSubmitSearch(submitMemory);
    initSubmitValidation(submitMemory);
}
